<template lang="pug">
div
	page-header(:title='title')
	form(@submit.prevent='gravar')
		.modal-body
			.form-horizontal
				vue-element-loading(:active='isActive', spinner='bar-fade-scale', color='#428BCA')
				.form-group(v-if="$route.params.id == 9")
					label.col-sm-3.control-label.no-padding-right
						| Selecione
					.col-sm-5
						.radio
							label
								input.ace(name='form-field-radio' type='radio' data-enpassusermodified='yes' value='1' v-model='type')
								span.lbl  Dispensa de Licitação N.º
						.radio
							label
								input.ace(name='form-field-radio' type='radio' data-enpassusermodified='yes' value='2' v-model='type')
								span.lbl  Aviso de Dispensa Cotação N.º
				.form-group
					label.col-sm-3.control-label.no-padding-right(for='numero')  Número
					.col-sm-9(v-if="$route.params.id != 9")
						the-mask.col-xs-10.col-sm-3.cpf(type='text' name='numero' :mask="mask[$route.params.id - 1]" :masked="true" v-model='form.numero' :placeholder='placeholder[$route.params.id - 1]' required='')
					.col-sm-9(v-else)
						the-mask.col-xs-10.col-sm-3.cpf(type='text' name='numero' :mask="type == 1 ? mask[8] : mask[11]" :masked="true" v-model='form.numero' :placeholder='type == 1 ? mask[8] : mask[11]' required='')
				.form-group
					label.col-sm-3.control-label.no-padding-right(for='titulo')  Descrição
					.col-sm-6
						textarea.form-control(v-model='form.titulo', placeholder='Descrição' v-autosize)
				.form-group
					select-form(v-model='form.ativo', :value='form.ativo', name='Ativo', url='/arquivos', id='id', titulo='nome', layout='true', optionText='Selecione', required='true')
		footer-button(:disabled='isActive')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import { TheMask } from 'vue-the-mask'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		TheMask
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Licitações',
			type: 1,
			form: {
				numero: '',
				titulo: '',
				ativo: '1',
				licitacao_categoria_id: ''
			},
			isActive: false,
			mask: [
				'Pregão Presenci!al n.###/####',
				'Pregão Eletrônico n.###/####',
				'Tom!ad!a de Preço n.###/####',
				'Concorrênci!a n.###/####',
				'Ch!amad!a Públic!a n.###/####',
				'C!art!a Convite n.###/####',
				'Credenci!amento nº ###/####',
				'!Adesão Nº ###/####',
				'Dispens!a de Licit!ação N.º ###/####',
				'Inexigibilid!ade n.###/####',
				'Leilão Eletrônico nº ###/####',
				'Pré-Qu!alific!ação N.º ###/####',
				'Cot!ação n° ###/####',
			],
			placeholder: [
				'Pregão Presencial n.###/####',
				'Pregão Eletrônico n.###/####',
				'Tomada de Preço n.###/####',
				'Concorrência n.###/####',
				'Chamada Pública n.###/####',
				'Carta Convite n.###/####',
				'Credenciamento nº ###/####',
				'Adesão Nº ###/####',
				'Dispensa de Licitação N.º ###/####',
				'Inexigibilidade n.###/####',
				'Leilão Eletrônico nº ###/####',
				'Pré-Qualificação N.º ###/####',
				'Cotação n° ###/####',
			]
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.cat) {
				await req(`/v1/licitacoes/categorias/${this.$route.params.id}/${this.$route.params.cat}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push(`/servicos/licitacoes/${this.$route.params.id}`)
			} else {
				await req(`/v1/licitacoes/categorias/${this.$route.params.id}`, 'post', body).catch(response => {
					'error: ' + response
					erro()
				})
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push(`/servicos/licitacoes/${this.$route.params.id}`)
			}
			this.isActive = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/v1/licitacoes/categorias/${this.$route.params.id}/${this.$route.params.cat}`).catch(response => {
				'error: ' + response
				erro()
			})
			this.form.numero = resp.numero
			this.form.titulo = resp.titulo
			this.form.ativo = resp.ativo
			this.form.licitacao_categoria_id = resp.licitacao_categoria_id
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		},
		async getDadosInitial() {
			const dados = await req(`/v1/licitacoes/${this.$route.params.id}`)
			this.title = dados.categoria
			this.form.licitacao_categoria_id = this.$route.params.id
		}
	},
	mounted() {
		this.getDadosInitial()
		this.verifPermissao()
		if (this.$route.params.cat) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
